import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { LocalstorageService } from 'src/app/global/localstorage.service';
import { NotificationService } from '../../../main/shared/notification.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  CurrentDate:string=formatDate(new Date(), 'dd/MM/yyyy', 'en');
  isUser: Boolean = false;
  language: string;
  showBtnBack: boolean = false;

  constructor(private notifyService:NotificationService, private router: Router) {
  }

  ngOnInit() {
    this.language = LocalstorageService.getLanguage('language');
    if(this.language == null) {
      this.language = 'en';
    }

    if(LocalstorageService.getLocal('user') != null) {
      this.isUser = true;
    }
    this.setBackButton();
  }

  logout() {
    LocalstorageService.logout('user');
    this.notifyService.showInfo("Logging Out","Info")
    window.location.replace('/');
  }

  setBackButton() {
    var url = this.router.url;
    console.log(url);
    if(url == "/" || url == "/PISDeviceStatus") {
      this.showBtnBack = false;
    } else {
      this.showBtnBack = true;
    }
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }
}
